import { useEffect, useState } from 'preact/hooks';
import { useCloudpack } from './CloudpackProvider.js';
import { taskStatsSource, type TaskStats } from '@ms-cloudpack/api-server/browser';

export const useTaskStats = (): TaskStats => {
  const cloudpack = useCloudpack();
  const [stats, setStats] = useState<TaskStats>({
    status: 'unknown',
    remainingTasks: 0,
    totalTasks: 0,
    totalErrors: 0,
    totalWarnings: 0,
  });

  useEffect(() => {
    const subscription = cloudpack?.onDataChanged.subscribe(taskStatsSource, {
      onData: (data) => {
        setStats(data as TaskStats);
      },
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [cloudpack]);

  return stats;
};
